/* eslint-disable import/extensions */
/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */
import React, { ReactElement } from "react";
import styled from "styled-components";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";

import { ThemeProvider } from "@material-ui/core/styles";

import selectTheme from "../theme/selectTheme";

interface ReactSelectProps {
  options: string[];
  label: string;
  onChange?: (any) => void;
  className?: string;
}

const StyledSelect = styled(Select)``;

const StyledFormControl = styled(FormControl)``;

const StyledMenuItem = styled(MenuItem)``;

const StyledReactSelect = ({
  options,
  label,
  onChange,
  className,
}: ReactSelectProps): ReactElement => {
  const [selectOption, setSelectOption] = React.useState("");

  const handleChange = (event): void => {
    setSelectOption(event.target.value);
    onChange(event.target.value);
  };
  return (
    <ThemeProvider theme={selectTheme}>
      <StyledFormControl variant="outlined" className={className}>
        <StyledSelect value={selectOption} onChange={handleChange}>
          {options.map((option, i) => {
            return (
              <StyledMenuItem key={i} value={option}>
                {option}
              </StyledMenuItem>
            );
          })}
        </StyledSelect>
      </StyledFormControl>
    </ThemeProvider>
  );
};

StyledReactSelect.defaultProps = {
  className: "",
  onChange: (): void => {
    // do nothing
  },
};

export default StyledReactSelect;
